var exports = {
  "si": "VoiceSceneSeatHud.module__hud___VzQwV1",
  "Os": "VoiceSceneSeatHud.module__group___VzQwV1",
  "pG": "VoiceSceneSeatHud.module__caption___VzQwV1",
};

module.exports = exports;
